import { useState, useEffect } from 'react';
import axios from 'axios';
import { Play, Pause, Download } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function RecordingPlayer({ callId }) {
  const [recording, setRecording] = useState(null);
  const [loading, setLoading] = useState(true);
  const [audioUrl, setAudioUrl] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [audio, setAudio] = useState(null);

  useEffect(() => {
    fetchRecording();
    return () => {
      if (audio) {
        audio.pause();
        audio.src = '';
      }
    };
  }, [callId]);

  const fetchRecording = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/recordings/${callId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRecording(response.data);
      if (response.data.exists && response.data.recording_url) {
        setAudioUrl(`${API_BASE}${response.data.recording_url}`);
      }
    } catch (error) {
      console.error('Error fetching recording:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePlay = () => {
    if (!audioUrl) return;

    if (!audio) {
      const newAudio = new Audio(audioUrl);
      newAudio.onended = () => setPlaying(false);
      setAudio(newAudio);
      newAudio.play();
      setPlaying(true);
    } else {
      if (playing) {
        audio.pause();
        setPlaying(false);
      } else {
        audio.play();
        setPlaying(true);
      }
    }
  };

  const handleDownload = () => {
    if (audioUrl) {
      const link = document.createElement('a');
      link.href = audioUrl;
      link.download = `recording-${callId}.wav`;
      link.click();
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="text-center py-4">Loading recording...</div>
      </div>
    );
  }

  if (!recording || !recording.exists) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="text-center py-4 text-gray-500">No recording available</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h3 className="text-lg font-semibold mb-4">Call Recording</h3>
      <div className="flex items-center gap-4">
        <button
          onClick={handlePlay}
          className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700"
        >
          {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5" />}
        </button>
        <button
          onClick={handleDownload}
          className="bg-gray-600 text-white p-3 rounded-full hover:bg-gray-700"
        >
          <Download className="w-5 h-5" />
        </button>
        {recording.size && (
          <div className="text-sm text-gray-600">
            Size: {(recording.size / 1024 / 1024).toFixed(2)} MB
          </div>
        )}
      </div>
    </div>
  );
}


